// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  projectId: __t.string().name("project_id"),
  folderId: __t.string().name("folder_id"),
  name: __t.string(),
  kind: __t.string(),
  mime: __t.string(),
  ext: __t.string(),
  sizeBytes: __t.f64().name("size_bytes"),
  totalBytes: __t.f64().name("total_bytes"),
  status: __t.string(),
  error: __t.string(),
  storageKey: __t.string().name("storage_key"),
  proxyKey: __t.string().name("proxy_key"),
  posterKey: __t.string().name("poster_key"),
  filmstripKey: __t.string().name("filmstrip_key"),
  filmstripTiles: __t.u32().name("filmstrip_tiles"),
  filmstripIntervalUs: __t.f64().name("filmstrip_interval_us"),
  waveformKey: __t.string().name("waveform_key"),
  durationUs: __t.f64().name("duration_us"),
  width: __t.u32(),
  height: __t.u32(),
  fps: __t.f64(),
  hasVideo: __t.bool().name("has_video"),
  hasAudio: __t.bool().name("has_audio"),
  audioChannels: __t.u32().name("audio_channels"),
  sampleRate: __t.u32().name("sample_rate"),
  videoCodec: __t.string().name("video_codec"),
  audioCodec: __t.string().name("audio_codec"),
  createdByUserId: __t.string().name("created_by_user_id"),
  createdByName: __t.string().name("created_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  scopeId: __t.string().name("scope_id"),
  spaceId: __t.string().name("space_id"),
  sourceId: __t.string().name("source_id"),
  sourceMissing: __t.bool().name("source_missing"),
  replacement: __t.string(),
});
